jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS

        // VideoJS Continue watching START
        scVjTracking();
        function scVjTracking(){
            $.each($('.video-js'), function(){
                var id = $(this).attr('id');
                if (id != undefined && !$('#'+id).hasClass('vj-tracking')) {
                    var plr = videojs(id),
                        source = plr.currentSrc().split("/").slice(-1)[0].replace(/\.(\w{3,4})(\?.*)?$/i, ''),
                        label = 'sc_vj_'+source,
                        progress = localStorage.getItem(label);
                    if (progress != undefined) {
                        var html = '<div class="continue-watching vj">Continue watching from where you left <button class="button videojs-continue" data-time="'+progress+'" data-id="'+id+'" data-file="'+label+'">Continue watching</button> <button class="button close-button" title="Close"><span class="icon-cancel"></span></button></div>';
                        $('#'+id).append(html);
                    }
                    plr.on('play', function(e, plr){
                        var currentTime = Math.round(this.currentTime()),
                            eventLabel = this.currentSrc().split("/").slice(-1)[0].replace(/\.(\w{3,4})(\?.*)?$/i, '');
                        localStorage.setItem('sc_vj_'+eventLabel, currentTime);
                    });
                    plr.on('timeupdate', function(e, plr){
                        var currentTime = Math.round(this.currentTime()),
                            eventLabel = this.currentSrc().split("/").slice(-1)[0].replace(/\.(\w{3,4})(\?.*)?$/i, '');
                        localStorage.setItem('sc_vj_'+eventLabel, currentTime);
                    });
                    plr.on('pause', function(e, plr){
                        var currentTime = Math.round(this.currentTime()),
                            eventLabel = this.currentSrc().split("/").slice(-1)[0].replace(/\.(\w{3,4})(\?.*)?$/i, '');
                        localStorage.setItem('sc_vj_'+eventLabel, currentTime);
                    });
                    plr.on('ended', function(e, plr){
                        var currentTime = Math.round(this.currentTime()),
                            eventLabel = this.currentSrc().split("/").slice(-1)[0].replace(/\.(\w{3,4})(\?.*)?$/i, '');
                        localStorage.removeItem('sc_vj_'+eventLabel);
                    });
                    $('#'+id).addClass('vj-tracking');
                }
            });
        }

        $('body').on('click', '.continue-watching  .close-button', function(){
            $(this).parent().remove();
        });

        $('body').on('click', '.continue-watching  .videojs-continue', function(){
            var id = $(this).attr('data-id'),
                time = $(this).attr('data-time'),
                plr = videojs(id);
            plr.currentTime(time);
            plr.play();
            $('.continue-watching').remove();
        });
        // VideoJS Continue watching END

        //Document Ready ENDS
    });
})(jQuery);

